var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{key:_vm.checked,staticClass:"checkbox-option",class:{ 'checkbox-option--truncate': _vm.truncate },attrs:{"label":_vm.option.value,"size":"large","checked":_vm.checked},on:{"change":_vm.handleChange}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.option.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }